<template>
  <div class="app">
    <root-container>
      <!-- router view ( login or main ) -->
      <router-view></router-view>
    </root-container>

    <pb-alert :options="options" />
  </div>
</template>

<script>
import RootContainer from "./common/RootContainer";

export default {
  name: "App",
  data: () => ({
    options: {
      position: "BOTTOM_CENTER"
    }
  }),
  components: {
    RootContainer
  }
};
</script>

<style lang="scss">
.app {
  width: 100%;
  height: 100%;
}
</style>